import React from 'react';
import styled from 'styled-components';
import Loader from '@commoncomponents/frontend-components/dist/components/Loader';
const LoaderWrapper = styled.div `
  width: 100%;
  height: 100%;

  & > div {
    width: 100%;
    height: 100%;
  }
`;
const LoaderWrapperStatement = ({ loaded, children, className, background = false, }) => loaded ? (children || null) : (React.createElement(LoaderWrapper, { className: `loader-wrapper ${className}` },
    React.createElement(Loader, { active: true, background: background })));
LoaderWrapperStatement.defaultProps = {
    className: '',
};
export default LoaderWrapperStatement;
